import EN from '../utils/multilanguageI18n/en.json';
import FR from '../utils/multilanguageI18n/fr.json';
import ES from '../utils/multilanguageI18n/es.json';
import DE from '../utils/multilanguageI18n/de.json';
import { defaultLanguage } from '../utils/userProfileContextHelpers';
import useUserProfile from './useUserProfile';

const translations = {
    en: EN,
    fr: FR,
    es: ES,
    de: DE,
};

const useTranslate = (text, overrideLang) => {
    const { language } = useUserProfile();
    const lang = overrideLang || language;

    const translate =
        (langCode = defaultLanguage) =>
        key => {
            return translations?.[langCode]?.[key] || key;
        };

    if (text === undefined) {
        return translate(lang);
    }
    return translate(lang)(text);
};

export default useTranslate;
